function Logo(props) {
  return (
    <div
      data-type="siteLogo"
      className={`flex max-h-full items-center py-3 pr-3  ${props.position &&props.position === 'footer' ? 'h-[32px] lg:h-[47px]' : 'h-[65px] md:h-[72px]'}`}
    >
      {/*
        The anchor constrains the logo to the header height via h-full,
        and limits width so it never overflows its column.
      */}
      <a href="/" title="Go to Homepage" className={`flex items-center justify-start max-w-full ${props.position && props.position === 'footer' ? 'h-[32px] lg:h-[47px]' : 'h-full'}`}>
        {(props.mobLogo || props.deskLogo) && (
          /*
            The picture element fills the anchor height but never exceeds it.
            width is kept as auto so the natural aspect ratio is always honoured.
          */
          <picture className="block h-full max-h-full max-w-full">
            {props.mobLogo && <source media="(max-width: 768px)" srcSet={props.mobLogo?.src} />}
            {props.deskLogo && <source media="(min-width: 769px)" srcSet={props.deskLogo?.src} />}
            {props.deskLogo && (
              /*
                - max-h-full: never taller than the header band
                - max-w-full: never wider than the containing column
                - w-auto / h-auto: let the browser calculate the opposite
                  dimension from the intrinsic aspect ratio
                - object-contain: belt-and-braces fallback so stretched
                  pixels are impossible even if a parent forces a size
              */
              <img
                className="max-h-full max-w-full w-auto h-auto object-contain"
                src={props.deskLogo.src}
                alt={props.deskLogo?.altText || props.mobLogo?.altText || 'Site Logo'}
              />
            )}
            {!props.deskLogo && props.mobLogo && (
              <span>{props.deskLogo?.altText || props.mobLogo?.altText || 'Site Logo'}</span>
            )}
          </picture>
        )}
        {!props.mobLogo && !props.deskLogo && <span>Home</span>}
      </a>
    </div>
  )
}

export default Logo
